import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import AnnouncementsFeed from '../components/AnnouncementsFeed';
import ExportButtons from '../components/ExportButtons';

function statusBadge(s) {
  const map = { 'Pending':'badge-pending','Needs Discussion':'badge-discuss','Discussed':'badge-discussed','Completed':'badge-completed' };
  return <span className={`badge ${map[s] || ''}`}>{s}</span>;
}

function TicketDetail({ id, onClose }) {
  const [t, setT] = useState(null);
  useEffect(() => { api.get(`/coordinator/ticket/${id}`).then(r => setT(r.data)).catch(()=>{}); }, [id]);
  if (!t) return null;
  return (
    <div className="modal-overlay" onClick={e => e.target===e.currentTarget && false && onClose()}>
      <div className="modal" style={{ maxWidth:560 }}>
        <div className="modal-header"><span className="modal-title"><span className="mono" style={{ color:'var(--accent)' }}>{t.task_id}</span></span><button className="modal-close" onClick={onClose}>×</button></div>
        <div style={{ marginBottom:8 }}>{statusBadge(t.status)} <span style={{ fontSize:12, color:'var(--text2)', marginLeft:6 }}>{t.category_name} · {t.campus_name} · {t.department}</span></div>
        <div style={{ fontWeight:600 }}>{t.title}</div>
        <div style={{ fontSize:13, color:'var(--text2)', margin:'4px 0 10px' }}>{t.description || '—'}</div>
        <div style={{ fontSize:12, color:'var(--text2)' }}>Raised by {t.teacher_name} · {new Date(t.created_at).toLocaleString()}</div>
        {t.assigned_to && <div style={{ fontSize:12, color:'var(--text2)' }}>Last updated by {t.assigned_to}</div>}
        {t.status==='Completed' && t.resolution && (
          <div style={{ background:'rgba(52,211,153,0.08)', border:'1px solid rgba(52,211,153,0.2)', borderRadius:'var(--radius)', padding:12, marginTop:10 }}>
            <div style={{ fontSize:12, fontWeight:600, color:'var(--green)', marginBottom:4 }}>✅ Resolution</div>
            <div style={{ fontSize:13 }}>{t.resolution}</div>
          </div>
        )}
        <div style={{ fontSize:12, fontWeight:600, color:'var(--text2)', textTransform:'uppercase', letterSpacing:'0.05em', margin:'14px 0 6px' }}>History</div>
        {!(t.history||[]).length ? <div style={{ fontSize:13, color:'var(--text2)' }}>No history.</div> : (
          <div style={{ borderLeft:'2px solid var(--border)', paddingLeft:12 }}>
            {t.history.map((h,i) => (
              <div key={i} style={{ marginBottom:8 }}>
                <div style={{ fontSize:13 }}>{h.action}{h.field_name?` · ${h.field_name}`:''}{h.new_value?`: ${h.new_value}`:''}</div>
                <div style={{ fontSize:11, color:'var(--text3)' }}>{h.by_name || '—'} · {new Date(h.created_at).toLocaleString()}</div>
              </div>
            ))}
          </div>
        )}
        <div className="modal-footer"><button className="btn btn-secondary" onClick={onClose}>Close</button></div>
      </div>
    </div>
  );
}

export default function CoordinatorContent() {
  const [page, setPage] = useState('home');
  const [dash, setDash] = useState(null);
  const [campuses, setCampuses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [staff, setStaff] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [filters, setFilters] = useState({ campus_id:'', status:'', category_id:'', from:'', to:'' });
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get('/coordinator/dashboard').then(r => setDash(r.data)).catch(()=>{});
    api.get('/coordinator/department-staff').then(r => setStaff(r.data)).catch(()=>{});
    api.get('/master/campuses').then(r => setCampuses(r.data.filter(c=>c.active))).catch(()=>{});
    api.get('/master/categories', { params:{ type:'staff' } }).then(r => setCategories(r.data)).catch(()=>{});
  }, []);

  const loadTickets = useCallback(() => {
    const params = {}; Object.entries(filters).forEach(([k,v]) => { if (v) params[k]=v; });
    api.get('/coordinator/tickets', { params }).then(r => setTickets(r.data)).catch(()=>{});
  }, [filters]);
  useEffect(() => { if (page==='tickets') loadTickets(); }, [page, loadTickets]);

  if (!dash) return <div style={{ padding:40, color:'var(--text2)' }}>Loading…</div>;
  const s = dash.summary || {}, tr = dash.trends || {};
  const set = (k,v) => setFilters(p => ({ ...p, [k]:v }));

  const KPI = ({ label, value, color, onClick }) => (
    <div className="card" onClick={onClick}
      style={{ flex:1, minWidth:130, textAlign:'center', cursor:onClick?'pointer':'default' }}
      onMouseEnter={e => onClick && (e.currentTarget.style.transform='translateY(-2px)')}
      onMouseLeave={e => e.currentTarget.style.transform='none'}>
      <div style={{ fontSize:24, fontWeight:700, color:color||'var(--text)' }}>{value ?? 0}</div>
      <div style={{ fontSize:12, color:'var(--text2)', marginTop:4 }}>{label}{onClick ? ' ›' : ''}</div>
    </div>
  );
  const TicketTable = ({ rows, empty }) => (
    <div className="card" style={{ padding:0, overflow:'hidden' }}>
      {!rows.length ? <div className="empty-state"><p>{empty}</p></div> : (
        <div className="table-wrap"><table>
          <thead><tr><th>Ticket</th><th>Teacher</th><th>Campus</th><th>Category</th><th>Status</th><th>Created</th><th>Assigned</th></tr></thead>
          <tbody>{rows.map(t => (
            <tr key={t.id} style={{ cursor:'pointer' }} onClick={() => setDetail(t.id)}>
              <td><span className="mono" style={{ fontSize:12, color:'var(--accent)' }}>{t.task_id}</span></td>
              <td style={{ fontSize:13 }}>{t.teacher_name}</td>
              <td style={{ fontSize:12 }}>{t.campus_name}</td>
              <td style={{ fontSize:12 }}>{t.category_name||'—'}</td>
              <td>{statusBadge(t.status)}</td>
              <td style={{ fontSize:12, color:'var(--text2)' }}>{new Date(t.created_at).toLocaleDateString()}</td>
              <td style={{ fontSize:12, color:'var(--text2)' }}>{t.assigned_to||'—'}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </div>
  );

  const nav = [['home','🏠 Home'],['tickets','🎫 Department Tickets'],['staff','👥 Department Staff']];

  return (
    <div>
      <div style={{ display:'flex', gap:0, marginBottom:18, borderBottom:'1px solid var(--border)', flexWrap:'wrap' }}>
        {nav.map(([id,label]) => (
          <button key={id} onClick={() => setPage(id)}
            style={{ padding:'9px 18px', fontSize:13, cursor:'pointer', background:'transparent', border:'none', whiteSpace:'nowrap',
              borderBottom: page===id?'2px solid var(--accent)':'2px solid transparent',
              color: page===id?'var(--accent)':'var(--text2)', fontWeight: page===id?600:400, marginBottom:-1 }}>{label}</button>
        ))}
      </div>

      <div>
          {page === 'home' && (
            <div>
              <h1 style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Department Dashboard</h1>
              <p style={{ fontSize:13, color:'var(--text2)', marginBottom:20 }}>Tickets raised by staff in your department(s): <b>{(dash.departments||[]).join(', ')}</b></p>

              <div className="flex-gap" style={{ gap:12, marginBottom:20, flexWrap:'wrap' }}>
                <KPI label="New" value={s.newc} color="var(--accent)" onClick={() => { set('status','Pending'); setPage('tickets'); }} />
                <KPI label="Pending" value={s.pending} color="var(--amber)" onClick={() => { set('status',''); setPage('tickets'); }} />
                <KPI label="Closed" value={s.closed} color="var(--green)" onClick={() => { set('status','Completed'); setPage('tickets'); }} />
                <KPI label="Total" value={s.total} color="var(--accent)" onClick={() => { set('status',''); setPage('tickets'); }} />
              </div>

              <div className="flex-gap" style={{ gap:12, marginBottom:20, flexWrap:'wrap' }}>
                <div className="card" style={{ flex:1, minWidth:240 }}>
                  <div style={{ fontSize:13, fontWeight:600, marginBottom:8 }}>This Month</div>
                  <div style={{ fontSize:13, display:'flex', flexDirection:'column', gap:4 }}>
                    <span>Raised: <b>{tr.raised_month||0}</b></span>
                    <span>Resolved: <b>{tr.resolved_month||0}</b></span>
                    <span>Avg resolution: <b>{tr.avg_hours!=null?tr.avg_hours+' h':'—'}</b></span>
                  </div>
                </div>
                <div className="card" style={{ flex:1, minWidth:240 }}>
                  <div style={{ fontSize:13, fontWeight:600, marginBottom:8 }}>Top Categories</div>
                  {!(tr.top_categories||[]).length ? <div style={{ fontSize:13, color:'var(--text2)' }}>—</div> :
                    tr.top_categories.map((c,i) => <div key={i} style={{ fontSize:13, display:'flex', justifyContent:'space-between' }}><span>{c.name||'—'}</span><b>{c.count}</b></div>)}
                </div>
              </div>

              <AnnouncementsFeed limit={4} />

              <h2 style={{ fontSize:15, fontWeight:600, margin:'4px 0 10px' }}>⚠ Pending / Critical</h2>
              <TicketTable rows={dash.critical||[]} empty="No critical or overdue tickets." />

              <h2 style={{ fontSize:15, fontWeight:600, margin:'20px 0 10px' }}>Recent Tickets</h2>
              <TicketTable rows={dash.recent||[]} empty="No tickets yet." />
            </div>
          )}

          {page === 'tickets' && (
            <div>
              <div className="flex-gap" style={{ justifyContent:'space-between', marginBottom:14, flexWrap:'wrap', gap:10 }}>
                <h2 style={{ fontSize:18, fontWeight:600 }}>Department Tickets</h2>
                <ExportButtons filename="department-tickets" title="Department Tickets" rows={tickets}
                  columns={[{key:'task_id',label:'Ticket'},{key:'teacher_name',label:'Teacher'},{key:'department',label:'Department'},{key:'campus_name',label:'Campus'},{key:'category_name',label:'Category'},{key:'status',label:'Status'},{key:'priority',label:'Priority'},{key:'created_at',label:'Created'},{key:'assigned_to',label:'Assigned'},{key:'resolution',label:'Resolution'}]} />
              </div>
              <div className="flex-gap" style={{ gap:8, marginBottom:12, flexWrap:'wrap' }}>
                <select value={filters.campus_id} onChange={e=>set('campus_id',e.target.value)} style={{ padding:'6px 8px' }}><option value="">All campuses</option>{campuses.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}</select>
                <select value={filters.status} onChange={e=>set('status',e.target.value)} style={{ padding:'6px 8px' }}><option value="">All statuses</option><option>Pending</option><option>Needs Discussion</option><option>Discussed</option><option>Completed</option></select>
                <select value={filters.category_id} onChange={e=>set('category_id',e.target.value)} style={{ padding:'6px 8px' }}><option value="">All categories</option>{categories.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}</select>
                <input type="date" value={filters.from} onChange={e=>set('from',e.target.value)} style={{ padding:'6px 8px' }} title="From" />
                <input type="date" value={filters.to} onChange={e=>set('to',e.target.value)} style={{ padding:'6px 8px' }} title="To" />
              </div>
              <TicketTable rows={tickets} empty="No tickets match." />
            </div>
          )}

          {page === 'staff' && (
            <div>
              <h2 style={{ fontSize:18, fontWeight:600, marginBottom:14 }}>Department Staff</h2>
              <div className="card" style={{ padding:0, overflow:'hidden' }}>
                {!staff.length ? <div className="empty-state"><p>No staff mapped to your department(s) yet.</p></div> : (
                  <div className="table-wrap"><table>
                    <thead><tr><th>Name</th><th>Designation</th><th>Department</th><th>Campus</th><th>Email</th></tr></thead>
                    <tbody>{staff.map(m => (
                      <tr key={m.id}>
                        <td style={{ fontSize:13, fontWeight:500 }}>{m.full_name}</td>
                        <td style={{ fontSize:12 }}>{m.designation||'—'}</td>
                        <td style={{ fontSize:12 }}>{m.department}</td>
                        <td style={{ fontSize:12 }}>{m.campuses||'—'}</td>
                        <td style={{ fontSize:12, color:'var(--text2)' }}>{m.email||'—'}</td>
                      </tr>
                    ))}</tbody>
                  </table></div>
                )}
              </div>
            </div>
          )}
      </div>
      {detail && <TicketDetail id={detail} onClose={() => setDetail(null)} />}
    </div>
  );
}
